module.exports = __webpack_public_path__ + "static/media/28-5.16b3b679.mp3";